<div class="container">
  <h3>{{ 'delete_account_header' | translate }}</h3>
  <p>
    <b>{{ 'delete_account_text' | translate }}</b>
  </p>
  <div class="buttons">
    <ion-button (click)="deleteAccount()"
      >{{ 'Accept' | translate }}
    </ion-button>
    <ion-button id="cancel-btn" (click)="dismiss()"
      >{{ 'Cancel' | translate }}
    </ion-button>
  </div>
</div>
